<template>
    <div>
        <div class="popup__header popup__header--no-bottom">
            <span class="title title--sm popup__title">{{ $lang('auth.title') }}</span>
        </div>
        <div class="popup__content">
            <errors :errors="errors"></errors>
            <form class="form" @submit.prevent="loginPost">
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('auth.input.title') }}</span>
                        <el-input class="input input--big"
                                  :placeholder="$lang('email.input.placeholder')"
                                  :disabled="isAuth"
                                  v-model="formAuth.login"
                                  required dusk="login"/>
                    </label>
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('auth.input2.title') }}</span>
                        <el-input class="input input--big" v-if="isAuth"
                                  value="*******"
                                  show-password
                                  :disabled="true"/>
                        <el-input class="input input--big" v-else
                                  type="password"
                                  placeholder="*******"
                                  v-model="formAuth.password"
                                  show-password dusk="password"/>
                    </label>
                </div>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg" dusk="login-button">{{ $lang('auth.button') }}</button>
                </div>
                <template v-if="!isAuth">
                  <div class="form__item form__item--small-margin form__item--inline">
                    <span class="popup__auth-hint">{{ $lang('auth.restore.text') }}</span>
                    <router-link class="link" :to="{ name: 'reset-password', params: { showRegistration: showRegistration }, query: $route.query }">
                      <span>{{ $lang('auth.restore.link') }}</span>
                    </router-link>
                  </div>
                  <div v-if="showRegistration" class="form__item form__item--inline">
                    <span class="popup__auth-hint">{{ $lang('auth.reg.text') }}</span>
                      <router-link class="link" :to="{ name: 'registration', query: { ...this.$route.query, redirect: getRedirectUrl() }}">
                      <span>{{ $lang('auth.reg.link') }}</span>
                      </router-link>
                  </div>
                </template>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations, mapGetters} from 'vuex';
    import helper from "../../mixins/helper";
    import Errors from "../error/errors";
    import ApiService from "../../api/api";

    const _ = require('lodash');

    export default {
        name: "Login",
        components: {Errors},
        mixins:[helper],
        props: {
            profile: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                errors: null,
                showRegistration: window.laravel.isAuth,
                prefix: window.laravel.prefix
            }
        },
        computed: {
            ...mapState('auth',[
                'formAuth',
            ]),
            ...mapGetters('auth', [
                'isAuth',
            ])
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
        mounted() {
            if (this.isAuth) {
                const params = (new URL(window.location)).searchParams;

                if (!!params.get('redirect') && params.get('redirect') === '/cabinet/tree') {
                    window.location.href = params.get('redirect');

                    return;
                }
                this.loadFormAuth();

                this.formAuth.login = String(this.formAuth.email).includes('@')
                    ? this.formAuth.email
                    : this.formAuth.phone;

                this.loginPost();
            }
        },
        methods: {
            ...mapActions('auth', [
                'login',
            ]),
            ...mapMutations('auth', [
                'clearData',
                'loadFormAuth'
            ]),
            getRedirectUrl() {
                const redirectUrl = window.laravel?.redirectUrl;

                return redirectUrl || this.$route.query.redirect;
            },
            loginPost() {
                this.phoneFormatted();

                this.$loading(this.$optionsLoading);

                const params = (new URL(window.location)).searchParams;

                if (!!params.get('redirect')) {
                    this.formAuth.redirect = params.get('redirect');
                }

                if (!Object.is(NaN, parseInt(params.get('client_id')))) {
                  if (!!params.get('redirect_url')) {
                    this.formAuth.client_id = parseInt(params.get('client_id'));
                    this.formAuth.redirect_url = params.get('redirect_url');

                    if (!!params.get('relation')) {
                      this.formAuth.relation = params.get('relation');
                    }
                  }
                }

                this.login()
                    .then((response) => {
                        this.onSuccess(response);
                    })
                    .catch((error) => {
                        this.$loading({}).close();

                        this.errors = error.response.data.errors;
                    });
            },
            onSuccess(response) {
                if (Object(response.data).hasOwnProperty('redirect')) {
                  window.location.href = response.data.redirect;

                  return;
                }

                // Редирект на онбординг для мастеров
                if (response.data.hasOwnProperty('user')
                    && response.data.user.hasOwnProperty('master_data')
                    && response.data.user.master_data
                    && !response.data.user.master_data.onboarding_accepted) {
                    window.location.href = '/cabinet/onboarding';

                    return;
                }

                if (this.profile) {
                    ApiService.post('/memories/' + this.profile.slug + '/subscribe').then((response) => {
                        window.location.href = this.prefix + '/memories/' + this.profile.slug;
                    }).catch((error) => {
                        console.log(error.response.data.errors);

                        this.$loading({}).close();
                    })
                } else {
                    window.location.href = window.laravel.redirectUrl ?? this.prefix + '/cabinet';
                }
            }
        },
    }
</script>
